import {
  ChannelFlagsInterface,
  NotificationChannel,
  NotificationGroup,
  NotificationOutcome,
  NotificationPreferencesInterface
} from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

// LINK apps/server/src/API/NotificationPreferences/NotificationPreferences.Controller.ts
export class NotificationPreferencesAPI {
  static async get(orgId: number, memberId: number): Promise<NotificationPreferencesInterface> {
    return APIService.Server.get<NotificationPreferencesInterface>(`/notification-preferences/org/${orgId}/member/${memberId}`);
  }

  static async update(
    orgId: number,
    memberId: number,
    body: {
      preferences?: Record<NotificationGroup, ChannelFlagsInterface>;
      notificationEmail?: string;
      notificationPhone?: string;
      autoSubscribeGroupSlugs?: string[];
    }
  ): Promise<NotificationPreferencesInterface> {
    return APIService.Server.put<NotificationPreferencesInterface>(`/notification-preferences/org/${orgId}/member/${memberId}`, body);
  }

  static async sendTest(orgId: number, memberId: number, channel: NotificationChannel): Promise<NotificationOutcome> {
    return APIService.Server.post<NotificationOutcome>(`/notification-preferences/org/${orgId}/member/${memberId}/test/${channel}`);
  }
}
